import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDialog } from 'src/app/general/services/dialog.service';
import { Consumer } from 'src/app/general/interfaces/functions';
import { MenuItemEditorDialogComponent } from './menu-item-editor-dialog.component';
import { MenuItemEditorDialogData } from '../util/interfaces';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public updateMenuEntry(menuEntry: proto.waiternow.common.StructuredMenuProto.IMenuEntryProto): void {
//   const inputDialogData: MenuEntryEditorDialogData = {
//     menuItem: {
//       nameEn: Formatter.getText(menuEntry.menuItem.name, proto.waiternow.common.Language.ENGLISH),
//       nameEs: Formatter.getText(menuEntry.menuItem.name, proto.waiternow.common.Language.SPANISH)
//     },
//     allCategories: ...
//   }
//   this.menuEntryEditorDialogService.openEditor(
//     inputDialogData,
//     /* onUpdate */ outputDialogData => {
//       console.log(outputDialogData);
//     }
//   );
// }

// ----------------------------------------------------------------------------

@Injectable({
  providedIn: 'root',
})
export class MenuItemEditorDialogService {

  constructor(private dialog: MatDialog) { }

  public openEditor(inputDialogData: MenuItemEditorDialogData, onUpdate: Consumer<MenuItemEditorDialogData>) : CloseDialog {
    const dialogRef = this.dialog.open(MenuItemEditorDialogComponent, {
      data: inputDialogData,
      autoFocus: true,
      hasBackdrop: true,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(outputDialogData => {
      if (outputDialogData) {
        onUpdate(outputDialogData);
      }
    });

    return () => dialogRef.close();
  }
}
